import { render, staticRenderFns } from "./RiderPayouts.vue?vue&type=template&id=0700fa0a"
import script from "./RiderPayouts.vue?vue&type=script&lang=js"
export * from "./RiderPayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports